import { t } from 'i18next'
import { z } from 'zod'

export const schema = z
  .object({
    firstName: z.string().min(1),
    invitationToken: z.string(),
    lastName: z.string().min(1),
    password: z.string().min(1),
    passwordConfirmation: z.string().min(1),
  })
  .superRefine((data, ctx) => {
    if (data.password !== data.passwordConfirmation) {
      ctx.addIssue({
        code: 'custom',
        message: t('features/user:completeSetup.form.passwordConfirmation.error'),
        path: ['passwordConfirmation'],
      })
    }
  })

export const schemaDefaults = (invitationToken: string): Schema => ({
  firstName: '',
  invitationToken,
  lastName: '',
  password: '',
  passwordConfirmation: '',
})

export type Schema = z.infer<typeof schema>
